import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  CANCEL_SUCCESS_BANNER_MS,
  createCancelServiceErrorBanner,
} from "../../../../common/components/OrderCancellation/order-cancellation.util";
import { HARDWARE_ORDERS_QUERY_KEY } from "../../../../common/hooks/use-hardware-orders-query";
import { useNotificationStore } from "../../../../common/stores/use-notification-store";
import { getString } from "../../../../common/uistringlabels/ui-string-utils";
import { amznhamOrderQueryKey } from "./use-amznham-order.hook";
import {
  cancellationService,
  CancellationResult,
} from "../../../../services/orders/cancellation-service";
import {
  CANCEL_STRINGS_PATH,
  CancellationReason,
} from "../../../../services/orders/cancellation.types";

export const useCancelAmznhamOrder = (orderId: string) => {
  const queryClient = useQueryClient();
  const addBanner = useNotificationStore((state) => state.addBanner);

  const mutation = useMutation<CancellationResult, Error, CancellationReason>({
    mutationFn: (reason) => cancellationService.cancelOrder(orderId, reason),
    onSuccess: (result) => {
      if (!result.success) {
        addBanner(
          result.error ? { type: "error", message: result.error } : createCancelServiceErrorBanner()
        );
        return;
      }
      addBanner(
        { type: "success", message: getString(`${CANCEL_STRINGS_PATH}.successMessage`) },
        CANCEL_SUCCESS_BANNER_MS
      );
      queryClient.invalidateQueries({ queryKey: amznhamOrderQueryKey(orderId) });
      queryClient.invalidateQueries({ queryKey: HARDWARE_ORDERS_QUERY_KEY });
    },
    onError: () => {
      addBanner(createCancelServiceErrorBanner());
    },
  });

  return { cancelOrder: mutation.mutate, isCancelling: mutation.isPending };
};
